/**
 * Sources the active tenant's REAL subscription (SubscriptionsController.GET /tenant) and
 * feeds the shared SubscriptionProvider with its effective feature set. Previously read a
 * dead legacy BFF route (`/billing/subscription`, from before the real SubscriptionsController
 * existed) via a hardcoded 3-tier plan model unrelated to the actual admin-editable plans —
 * always silently fell back to a fixed default. Empty features while loading/logged-out/never
 * subscribed, so the UI never blocks or over-grants.
 */
import { type ReactNode } from 'react'
import { SubscriptionProvider } from '@shared/subscription'
import { useTenantSubscription } from '@/hooks/data/useSubscriptions'
import { useAuthStore } from '@/hooks/auth/useAuthStore'
import type { Feature } from '@shared/subscription'

export default function TenantSubscriptionProvider({ children }: { children: ReactNode }) {
  const { data } = useTenantSubscription()
  const isAdmin = useAuthStore((s) => s.hasRole('admin'))
  return (
    <SubscriptionProvider
      planName={data?.plan?.name ?? null}
      features={(data?.effectiveFeatures ?? []) as Feature[]}
      status={data?.status ?? 'none'}
      renewsAt={data?.renewsAt}
      isAdmin={isAdmin}
    >
      {children}
    </SubscriptionProvider>
  )
}
